<template>
  <div>
    <div class="mb-3">
      <h5>Manage Items</h5>
    </div>

    <div class="text-center" v-if="isInitialisingUI">
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <div v-else>
      <b-card>
        <AdminDropdown for="sections"
          preventSelectDefaultItem
          v-on:dropdownItemChanged="selectedSectionChanged" />
        <AdminDropdown for="wordcategories"
          v-on:dropdownItemChanged="selectedWordCategoryChanged" />
      </b-card>
      <div>
        <b-table striped bordered hover
          stacked="md"
          v-bind:items="items"
          v-bind:fields="tableFields"
          v-bind:busy="tableIsBusy"
          show-empty
          empty-text="No data to show">
          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
          <template #cell(actions)="data">
            <b-button class="mr-2" size="sm" variant="info"
              title="Edit"
              v-on:click="editItemClick(data.item)">
              <b-icon-pencil />
            </b-button>
            <b-button class="mr-2" size="sm" variant="danger"
              title="Delete"
              v-on:click="deleteItemClick(data.item)">
              <b-icon-x-circle />
            </b-button>
          </template>
        </b-table>
        <b-pagination
          v-model="pageNumber"
          v-bind:total-rows="totalItemsCount"
          v-bind:per-page="itemsCountPerPage"
          v-bind:disabled="tableIsBusy"
          v-on:change="onPageChange"
          align="center">
        </b-pagination>
      </div>
      <div>
        <b-button variant="primary"
        v-bind:disabled="addButtonIsDisabled"
        v-on:click="addItemClick">
          Add item <b-icon-plus-circle />
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import AdminDropdown from '../components/AdminDropdown.vue';

export default {
  name: 'Items',
  components: { AdminDropdown },
  data() {
    return {
      pageNumber: 1,
      tableFields: [
        { key: 'name', thStyle: { width: '40%' } },
        { key: 'wordCategoryName', label: 'Word Category', thStyle: { width: '40%' } },
        { key: 'actions', thStyle: { width: '20%' } },
      ],
      isInitialisingUI: false,
    };
  },
  created() {
    this.initialiseUI();
  },
  computed: {
    wordCategories() {
      return this.$store.state.wordCategories.wordCategories;
    },
    items() {
      return this.$store.state.items.items;
    },
    totalItemsCount() {
      return this.$store.state.items.totalItemsCount;
    },
    itemsCountPerPage() {
      return this.$store.state.applicationSettings.itemsCountPerPage;
    },
    tableIsBusy() {
      return this.$store.state.items.isLoading;
    },
    addButtonIsDisabled() {
      return this.$store.state.items.isLoading
      || this.$store.state.sections.selectedSectionId === null;
    },
    searchItemsParams() {
      return {
        pageNumber: this.pageNumber,
        pageSize: this.itemsCountPerPage,
        sectionId: this.$store.state.sections.selectedSectionId,
        wordCategoryId: this.$store.state.wordCategories.selectedWordCategoryId,
      };
    },
  },
  methods: {
    ...mapActions('sections', ['getSections']),
    ...mapActions('wordCategories', ['searchWordCategories']),
    ...mapActions('items', ['searchItems', 'deleteItem']),
    async initialiseUI() {
      this.isInitialisingUI = true;

      try {
        await this.getSections();

        if (this.$store.state.sections.selectedSectionId) {
          await this.searchWordCategories({
            sectionId: this.$store.state.sections.selectedSectionId,
          });
          await this.searchItems(this.searchItemsParams);
        } else {
          this.$store.dispatch('wordCategories/clearState');
          this.$store.dispatch('items/clearState');
        }
      } catch (error) {
        this.handleHttpError(error);
        this.$store.dispatch('sections/clearState');
        this.$store.dispatch('wordCategories/clearState');
        this.$store.dispatch('items/clearState');
      }

      this.isInitialisingUI = false;
    },
    async onPageChange(value) {
      this.pageNumber = value;

      await this.searchItems(this.searchItemsParams)
        .catch((error) => {
          this.handleHttpError(error);
          this.$store.dispatch('items/clearState');
        });
    },
    async selectedSectionChanged() {
      this.pageNumber = 1;

      try {
        await this.searchWordCategories({
          sectionId: this.$store.state.sections.selectedSectionId,
        });
        await this.searchItems(this.searchItemsParams);
      } catch (error) {
        this.handleHttpError(error);
        this.$store.dispatch('wordCategories/clearState');
        this.$store.dispatch('items/clearState');
      }
    },
    async selectedWordCategoryChanged() {
      this.pageNumber = 1;
      await this.searchItems(this.searchItemsParams)
        .catch((error) => {
          this.handleHttpError(error);
          this.$store.dispatch('items/clearState');
        });
    },
    addItemClick() {
      this.$router.push({
        name: 'Admin-ItemDetails',
        params: {
          item: {
            id: 0,
            name: '',
            sectionId: this.$store.state.sections.selectedSectionId,
            wordCategoryId: this.$store.state.wordCategories.selectedWordCategoryId,
          },
          new: true,
        },
      });
    },
    editItemClick(item) {
      this.$router.push({
        name: 'Admin-ItemDetails',
        params: {
          item,
          new: false,
        },
      });
    },
    async deleteItemClick(item) {
      this.$bvModal.msgBoxConfirm(
        `Are you sure you want to delete "${item.name}"?`, {
          title: 'Delete Item',
          okVariant: 'danger',
          centered: true,
          hideHeaderClose: false,
        },
      )
        .then(async (value) => {
          if (value) {
            await this.deleteItem(item.id)
              .then(async () => {
                this.pageNumber = 1;
                await this.searchItems(this.searchItemsParams);
              })
              .catch((error) => { this.handleHttpError(error); });
          }
        });
    },
  },
};
</script>
